import { render, staticRenderFns } from "./boxItems.vue?vue&type=template&id=1b42bb76&"
import script from "./boxItems.vue?vue&type=script&lang=js&"
export * from "./boxItems.vue?vue&type=script&lang=js&"
import style0 from "./boxItems.vue?vue&type=style&index=0&id=1b42bb76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports